import { LlmState } from './types';

export const state = (): LlmState => ({
  answer: '',
  isLoading: false,
});
